export default "<template>\n\n  <KTextbox\n    label=\"Enter password\"\n    type=\"password\"\n    value=\"My password\"\n  />\n\n</template>\n";